export interface MaterialOrderType {
    id: number;
    estimation_id: number | null;
    quantity: number | null;
    unit_price: number | null;
    total: number | null;
    date: string | null;
}

// to single object maping
export const mapMaterialOrderType = (data: any): MaterialOrderType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialOrderType: MaterialOrderType = {
        id: data.id,
        estimation_id: data.estimation_id || null,
        quantity: data.quantity || null,
        unit_price: data.unit_price || null,
        total: data.total || null,
        date: data.date || null,
    }

    return materialOrderType;
}

// maping list objects
export const mapMaterialOrderTypes = (data: any[]): MaterialOrderType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    
    return data.map(mapMaterialOrderType);
}